<template>
    <div class="button-container" v-if="valve">
        <button class="btn btn-valve" :class="{'draggable' : draggable}">
            <div class="name" v-text="translate(valve.name)"></div>
            <div class="actions">
                <img @click="$emit('edit', buildIndex)" :src="getImage('pencil-blue.svg')"/>
                <img @click="remove" :src="getImage('close-danger.svg')"/>
            </div>
        </button>
    </div>
</template>

<script>
  import CoddButton from '../../input/Button'
  import {mapGetters, mapMutations, mapState} from 'vuex'

  export default {
    name: 'ValvesExtraItem',

    components: {
      CoddButton,
    },

    props: {
      valve: {
        required: false,
        type: Object,
      },
      buildIndex: {
        required: true,
        type: Number,
      },
      draggable: {
        required: false,
        type: Boolean,
      },
    },

    data() {
      return {
        active: false,
      }
    },

    computed: {
      ...mapState({
        allValves: state => state.valves.all,
      }),
      ...mapGetters({
        valves: 'build/valves/getValves',
      }),
      ownValves() {
        return this.valves.map((v) => this.allValves[v.id]);
      },
    },

    methods: {
      ...mapMutations({
        removeValve: 'build/valves/removeValve'
      }),
      remove() {
        const flippedIndex = this.ownValves.length - this.buildIndex - 1;
        if(confirm('Weet je zeker dat je deze klep wilt verwijderen?')) this.removeValve(flippedIndex);
      },
      logChange(e) {
        console.log(e)
      }
    },
  }
</script>

<style lang="scss" scoped>
    .button-container {
      width: 100%;
        margin-right: 5px;
    }

    .btn-valve {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 50px;
        font-size: 10px;
        border: 1px solid #3DB0C7;
        height: 32px;
        padding: 0 6px 0 16px;
        width: 100%;
        text-align: left;
        transition: all ease 0.3s;
        margin-bottom: 8px;
        margin-right: 10px;
        cursor: default;

        .name {
            width: 80%;
            line-height: 19px;
            text-align: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .actions {
            margin-left: auto;

            > * {
                cursor: pointer;

                &:first-child {
                    margin-right: 4px;
                }

                &:hover {
                    transform: scale(1.3);
                }
            }
        }

        span {
            font-size: 12px;
            font-family: neue-haas-grotesk-display, sans-serif;
            letter-spacing: 0.5px;
            transition: all ease 0.3s;
        }

        &.draggable {
            cursor: move;
        }
    }
</style>
